import React from 'react'
import ReactDOM from 'react-dom'
import store from './redux/store'
import { Provider } from 'react-redux'
import { HashRouter as Router, Route, Switch, Link } from 'react-router-dom'
import SolicitarCotacao from './SolicitarCotacao'
import Home from './Home'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <div>
          <div>
            <header
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Link to='/'>
                <img
                  src={'/images/LOGO.png'}
                  alt={'logo'}
                  style={{
                    width: '200px',
                    height: '100px',
                    marginLeft: '50px',
                  }}
                ></img>
              </Link>
              <div>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Inicio
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  A Empresa
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Logística
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Nossas Marcas
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Cadastro de Fornecedores
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Trabalhe conosco
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Fale conosco
                </a>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.sannaalimentos.com.br/'
                  style={{
                    padding: '10px',
                    textTransform: 'uppercase',
                    color: '#c9302c',
                    textDecoration: 'none',
                  }}
                >
                  Blog Sanna
                </a>
              </div>
            </header>
          </div>

          <hr />

          <Switch>
            <Route exact path='/'>
              <Home />
            </Route>
            <Route path='/cotacao'>
              <SolicitarCotacao />
            </Route>
          </Switch>
        </div>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
